import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import InputRadio from 'components/atoms/inputs/input-radio';

class FilterByConfirmed extends Component {
    onSelectConfirmed(selectedValue) {
        this.props.dispatch(Action.set('PlayerConfirmedFilter', selectedValue));
    }

    render() {
        const {sportConfig, selectedValue} = this.props;

        const inputRadios = [];
        const isChecked = Const.PLAYERS_CONFIRMED_FILTER_ALL === selectedValue;

        inputRadios.push(
            <InputRadio
                key={Const.PLAYERS_CONFIRMED_FILTER_ALL}
                label="All"
                value={Const.PLAYERS_CONFIRMED_FILTER_ALL}
                checked={isChecked}
                onChange={::this.onSelectConfirmed}
            />,
        );

        const confirmedOptions = sportConfig.getConfigProp('confirmed');

        Object.keys(confirmedOptions).map((key) => {
            const isChecked = key === selectedValue;
            inputRadios.push(
                <InputRadio
                    key={key}
                    label={confirmedOptions[key]}
                    value={key}
                    checked={isChecked}
                    onChange={::this.onSelectConfirmed}
                />,
            );
        });

        return (
            <div>
                <strong className="filter-sub-title">Select Confirmed:</strong>
                <div className="form-inline">{inputRadios}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, sportConfig} = state;

    return {
        selectedValue: playersData.filters.playerConfirmed,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(FilterByConfirmed);
